module.exports = __webpack_public_path__ + "static/media/fanyuvo_etterem_etlap.cb322cb2.pdf";